"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAnqColumns = exports.convertChildrenToColumns = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function convertChildrenToColumns(children) {
    return react_1.default.Children.toArray(children).filter(function (node) {
        return react_1.default.isValidElement(node);
    }).map(function (_a) {
        var key = _a.key, props = _a.props;
        var nodeChildren = props.children, restProps = tslib_1.__rest(props, ["children"]);
        var column = tslib_1.__assign({ key: key }, restProps);
        if (nodeChildren) {
            column.children = convertChildrenToColumns(nodeChildren);
        }
        return column;
    });
}
exports.convertChildrenToColumns = convertChildrenToColumns;
function transformAnqColumns(transforms, columns) {
    var transform = function (columns) {
        return transforms.reduce(function (transformResult, transformF) { return transformF(transformResult); }, columns);
    };
    var _transformAnqColumns = function (transform, columns) {
        return columns.map(function (column) {
            var cloneColumn = tslib_1.__assign({}, column);
            if ('children' in cloneColumn) {
                cloneColumn.children = _transformAnqColumns(transform, cloneColumn.children);
            }
            return transform(cloneColumn);
        });
    };
    return _transformAnqColumns(transform, columns);
}
exports.transformAnqColumns = transformAnqColumns;
//# sourceMappingURL=useColumns.js.map